export function getPriceAsNumber(price?: string | number) {
  if (typeof price === 'string') {
    const numericValue = parseFloat(price.replace(/[^.\d]/g, ''));

    return isNaN(numericValue) ? null : numericValue;
  }

  return typeof price === 'number' ? price : null;
}
